/**
 * SitePick front — 一覧の dataLayer（docs/10 §6）
 *
 * `view_item_list`（サーバ描画の一覧）と `select_item`（カードクリック）。
 * カードに埋まった `data-sp-item='{json}'` を唯一の元データにする（価格の二重管理をしない）。
 * `/favorites/` `/compare/` は各ページモジュールが自前で push するのでここでは扱わない。
 */

import { push, readItem } from "./analytics.js";

/**
 * サーバ描画の一覧について、item_list_id ごとに 1 回だけ `view_item_list`。
 */
function fireViewItemList() {
  const cards = Array.from(document.querySelectorAll("[data-sp-item]")).filter(
    (el) => !el.closest("[data-sp-page]")
  );
  if (cards.length === 0) {
    return;
  }

  /** @type {Map<string, Object[]>} */
  const lists = new Map();
  cards.forEach((el) => {
    const item = readItem(el);
    if (!item) {
      return;
    }
    const listId = item.item_list_id || "sites";
    if (!lists.has(listId)) {
      lists.set(listId, []);
    }
    lists.get(listId).push(item);
  });

  const guardKey = `sp_vil_${window.location.pathname}${window.location.search}`;
  let already = "";
  try {
    already = window.sessionStorage.getItem(guardKey) || "";
  } catch {
    already = "";
  }
  const seen = new Set(already ? already.split(",") : []);

  lists.forEach((items, listId) => {
    if (seen.has(listId)) {
      return;
    }
    push("view_item_list", { item_list_id: listId, items });
    seen.add(listId);
  });

  try {
    window.sessionStorage.setItem(guardKey, Array.from(seen).join(","));
  } catch {
    /* private mode 等。ガードなしで動作 */
  }
}

/**
 * カードのリンククリックで `select_item`。
 *
 * @param {Event} event
 */
function onClick(event) {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) {
    return;
  }
  const link = target.closest("a");
  if (!link) {
    return;
  }
  const holder = link.closest("[data-sp-item]");
  if (!holder) {
    return;
  }
  const item = readItem(holder);
  if (item) {
    push("select_item", { item_list_id: item.item_list_id || "sites", items: [item] });
  }
}

/**
 * 初期化。
 *
 * @returns {void}
 */
export function initListTracking() {
  fireViewItemList();
  document.addEventListener("click", onClick);
  // ファセット等で一覧が差し替わったら、新しいリストで view_item_list を再送。
  document.addEventListener("sitepick:content:updated", fireViewItemList);
}
